"use client";

import { track } from "@vercel/analytics";
import { useRouter } from "next/navigation";
import React from "react";

interface TrackedLinkProps {
  href: string;
  eventName: string;
  children: React.ReactNode;
  className?: string;
}

export default function TrackedLink({
  href,
  eventName,
  children,
  className,
}: TrackedLinkProps) {
  const router = useRouter();

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (eventName) {
      track(eventName);

      // Give analytics a moment to send before navigating
      setTimeout(() => {
        router.push(href);
      }, 150); // 100–300ms is usually fine
    } else {
      router.push(href);
    }
  };

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
